import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Avatar, AvatarImage, AvatarFallback } from 'components/ui/avatar'
import { Trash2, MapPin } from 'lucide-react'
import { initializeActiveLocations } from 'slices/locationSlice'
import { removeLocationFromPortfolio } from 'slices/portfolioSlice'

const SidebarPortfolioAddLocation = () => {
	const { id: portfolioId } = useParams()
	const dispatch = useDispatch()

	const { portfolio, isInitialized: success } = useSelector(state => {
		return {
			portfolio: state.portfolios.entities[portfolioId] || {},
			isInitialized: state.portfolios.isInitialized,
		}
	})

	const locationEntities = useSelector(state => state.locations.entities)

	const dropLocationFromPortfolio = async id => {
		await dispatch(removeLocationFromPortfolio({ portfolioId, locationId: id }))
		if (success) {
			await dispatch(initializeActiveLocations())
		}
	}

	const portfolioLocations = portfolio.locations || []
	const isEmpty = portfolioLocations?.length === 0

	return (
		<div className="flex flex-col">
			<div className="px-4 py-3 border-b border-gray-100">
				<span className="flex items-center gap-2 text-gray-600 text-base font-semibold">
					<MapPin className="w-4 h-4" /> Portfolio Locations
				</span>
			</div>
			<div className="overflow-y-auto max-h-[400px]">
				{isEmpty ? (
					<div className="flex items-center justify-center p-4">
						<h3 className="text-[#0080fe] opacity-30 text-sm font-light text-center">
							No Locations
						</h3>
					</div>
				) : success ? (
					<div>
						{portfolioLocations.map(portfolioLocation => {
							const location = locationEntities[portfolioLocation.location._id]
							if (!location) return null
							return (
								<div key={location._id} className="flex items-center px-4 py-2 hover:bg-gray-50">
									<Avatar className="h-9 w-9 mr-3 shrink-0">
										<AvatarImage src={location.image} />
										<AvatarFallback />
									</Avatar>
									<div className="flex-1 min-w-0">
										<div className="text-sm text-gray-900 truncate">{location.assetName}</div>
										<div className="text-xs text-gray-500 truncate">{`${location.city} - ${location.stateProvince}`}</div>
									</div>
									<button
										type="button"
										title="Remove"
										className="shrink-0 p-1 text-gray-400 hover:text-red-500"
										onClick={() => dropLocationFromPortfolio(location._id)}
									>
										<Trash2 className="w-4 h-4" />
									</button>
								</div>
							)
						})}
					</div>
				) : null}
			</div>
		</div>
	)
}

export default SidebarPortfolioAddLocation
